export const dummyTransformations = [
  {
    id: '1',
    createdAt: new Date(),
    description: '',
    fileExtension: 'png',
    fileId: 'FDtkdJOV2pE7791SlT8a',
    imageUrl: 'https://storage.googleapis.com/simply-public-assets/dummy/1.png',
    title: 'Samantha lost 10 kg in just 2 months',
  },
  {
    id: '2',
    createdAt: new Date(),
    description:
      'See how a busy mom achieved her goals with Liftedbylennart and lost 13 kg over the summer with an optimised diet plan and 3 weekly workouts.',
    fileExtension: 'png',
    fileId: 'FDtkdJOV2pE7791SlT8a',
    imageUrl: 'https://storage.googleapis.com/simply-public-assets/dummy/2.png',
    title: 'Sophie got a healthy relationship with food',
  },
  {
    id: '3',
    createdAt: new Date(),
    description: '',
    fileExtension: 'png',
    fileId: 'FDtkdJOV2pE7791SlT8a',
    imageUrl: 'https://storage.googleapis.com/simply-public-assets/dummy/3.png',
    title: 'John wanted to get rid of the dadbod',
  },
  {
    id: '4',
    createdAt: new Date(),
    description: '',
    fileExtension: 'png',
    fileId: 'FDtkdJOV2pE7791SlT8a',
    imageUrl: 'https://storage.googleapis.com/simply-public-assets/dummy/4.png',
    title: 'Matthew went through a 12 month rebuild of his body',
  },
];
